import { AvailabilityTypeSimple } from '@dreryk/egabinet-appointment-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../translations';
import { AvailabilityFormController } from '../common/common.types';
import { triggerLabelExtractor } from '../common/common.utils';

type AvailabilityTypeSelectProps = {
   readonly register: AvailabilityFormController['register'];
   readonly availabilityTypes: AvailabilityTypeSimple[];
};

export const AvailabilityTypeSelect = (props: AvailabilityTypeSelectProps): JSX.Element => {
   return (
      <Select<AvailabilityTypeSimple>
         testId={'availabilityType'}
         label={personnelTranslationKeys.visitEncounterMode}
         triggerLabelExtractor={triggerLabelExtractor}
         controller={props.register('availabilityTypeId', { required: true })}
      >
         <Select.List items={props.availabilityTypes} keyExtractor={'id'}>
            {(item: AvailabilityTypeSimple) => (
               <Select.Item item={item} label={createTranslatedText(item.name)} testId={item.name} />
            )}
         </Select.List>
      </Select>
   );
};
